import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Link, useHistory, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_WATER_STATION,
  GET_STATUS_WATER_STATION,
  GET_WATER_STATION_BY_ID,
  UPDATE_WATER_STATION,
} from '../../../../graphql/Catalog/WaterStations/waterstations'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import InputController from '../../../Global/InputController'
import ContentHeader from '../../../Layout/ContentHeader'
import GoogleMapComponentV2 from '../../../Global/GoogleMapComponentV2'
const WaterStationsNew = () => {
  const { id: _id } = useParams()
  const { showLoading, hideLoading } = useLoading()
  const history = useHistory()
  const [isReady, setIsReady] = useState(false)

  const [nameWaterStation, setNameWaterStation] = useState('')
  //STATES FOR GOOGLE MAPS
  const [coordinates, setCoordinates] = useState(null)
  const [isEditingMarkerPosition, setIsEditingMarkerPosition] = useState(false)
  const [address, setAddress] = useState(null)

  //OPTIONS
  const [statusOptions, setStatusOptions] = useState([])

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    manager: Yup.string().required('Campo requerido'),
    contact_info: Yup.string().required('Campo requerido'),
    address: Yup.string().required('Campo requerido'),
    status: Yup.string().required('Campo requerido'),
    start_hour: Yup.string(),
    end_hour: Yup.string().test(
      'is-greater',
      'La hora de cierre debe ser mayor a la de inicio',
      function (value) {
        const { start_hour } = this.parent
        return start_hour < value
      }
    ),
    // operating_hours: Yup.string(),
    location: Yup.string(),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const { loading, error, data } = useQuery(GET_WATER_STATION_BY_ID, {
    variables: {
      getWaterStationByIdId: +_id,
    },
    fetchPolicy: 'no-cache',
    skip: !_id,
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
  } = useQuery(GET_STATUS_WATER_STATION, {
    variables: {},
    fetchPolicy: 'only-cache',
  })

  const [createStation] = useMutation(CREATE_WATER_STATION)
  const [updateStation] = useMutation(UPDATE_WATER_STATION)

  useEffect(() => {
    try {
      if (!_id) return
      if (loading) return
      if (error) throw error

      if (!data.getWaterStationById)
        throw new Error('No se encontró la estación de agua')

      const { getWaterStationById } = data

      const splitOperatingHours = getWaterStationById.operating_hours.split('-')
      const startHour = splitOperatingHours[0]
      const endHour = splitOperatingHours[1]

      reset({
        name: getWaterStationById.name,
        manager: getWaterStationById.manager,
        contact_info: getWaterStationById.contact_info,
        address: getWaterStationById.address,
        status: getWaterStationById.status,
        start_hour: startHour,
        end_hour: endHour,
        location: getWaterStationById.location,
      })

      setNameWaterStation(getWaterStationById.name)
      setIsEditingMarkerPosition(getWaterStationById.location)
      setIsReady(true)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    try {
      if (loadingStatus) return
      if (errorStatus) throw errorStatus

      setStatusOptions(dataStatus.getStatusForWaterStation)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataStatus, errorStatus, loadingStatus])

  useEffect(() => {
    if (coordinates) {
      const formattedCoordinates = `${coordinates.lat},${coordinates.lng}`
      setValue('location', formattedCoordinates)
    } else setValue('location', '')

    if (address) {
      const getAddressComplete = address.formatted_address
      setValue('address', getAddressComplete)
    } else setValue('address', '')
  }, [coordinates, address])

  useEffect(() => {
    const isFormReady =
      !_id || (!loading && !error && data?.getWaterStationById)
    const isStatusReady =
      !loadingStatus && !errorStatus && dataStatus?.getStatusForWaterStation

    if (isFormReady && isStatusReady) {
      setIsReady(true)
    }
  }, [loading, error, data, loadingStatus, errorStatus, dataStatus, _id])

  const onSubmit = async (data) => {
    showLoading()
    try {
      if (_id) {
        const { data: dataUpdate } = await updateStation({
          variables: {
            updateWaterStationId: +_id,
            waterStation: {
              name: data.name,
              manager: data.manager,
              contact_info: data.contact_info,
              address: data.address,
              status: data.status,
              operating_hours: `${data.start_hour}-${data.end_hour}`,
              location: data.location,
            },
          },
        })

        if (dataUpdate.updateWaterStation) {
          return toastSweetAlert(
            {
              mode: 'ok',
              message: 'Estación de agua actualizada correctamente',
            },
            history.push('/waterstations')
          )
        }
      }

      const { data: dataCreate } = await createStation({
        variables: {
          waterStation: {
            name: data.name,
            manager: data.manager,
            contact_info: data.contact_info,
            address: data.address,
            status: data.status,
            operating_hours: `${data.start_hour}-${data.end_hour}`,
            location: data.location,
          },
        },
      })

      if (dataCreate.createWaterStation) {
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Estación de agua creada correctamente',
          },
          history.push('/waterstations')
        )
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  const handleCleanErrorMap = () => {
    setValue('location', '')
    setValue('address', '')
    setCoordinates(null)
  }

  return (
    <>
      <ContentHeader
        title=""
        windowTitle={
          _id
            ? `Editar estación de agua ${nameWaterStation}`
            : 'Agregar estación de agua'
        }
        breadcrumb=""
      />

      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            {/* <Link
              className="btn btn-migrates-white mb-3"
              to={`/waterstations`}
            >
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link> */}
            <h1 className="header-title">
              {' '}
              {_id
                ? `Editar estación de agua ${nameWaterStation}`
                : 'Agregar estación de agua'}
            </h1>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`Detalles de la estación`}
            btnSubmit
            clasCard="card report-water-station"
            btnSubmitText={`${_id ? 'Editar' : 'Agregar'} estación`}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <InputController
                      control={control}
                      name="name"
                      label="Nombre"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      control={control}
                      name="status"
                      label="Estatus"
                      inputType="choosen"
                      options={statusOptions}
                      placeholderTxt="Selecciona un estatus"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      control={control}
                      name="manager"
                      label="Encargado"
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <InputController
                      control={control}
                      name="contact_info"
                      label="Contacto"
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mb-3">
                    {/* <InputController
                      control={control}
                      name="operating_hours"
                      label="Horario de operación"
                    /> */}
                    <InputController
                      control={control}
                      name="start_hour"
                      label="Hora de inicio"
                      type="time"
                    />
                  </div>
                  <div className="col-l2 col-sm-12 col-md-3 col-lg-3 col-xl-3 mb-3">
                    <InputController
                      control={control}
                      name="end_hour"
                      label="Hora de cierre"
                      type="time"
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <InputController
                      control={control}
                      name="address"
                      label="Dirección"
                      disabled
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <InputController
                      control={control}
                      name="location"
                      label="Ubicación"
                      disabled
                    />
                  </div>
                  {/* <GoogleMapComponent
                    setCoordinates={setCoordinates}
                    address={address?.formatted_address || address}
                    setAddress={setAddress}
                    isEditingMarkerPosition={isEditingMarkerPosition}
                    style={{marginBottom: '20px'}}
                    handleCleanErrorMap={handleCleanErrorMap}
                  /> */}
                  {isReady && (
                    <GoogleMapComponentV2
                      setCoordinates={setCoordinates}
                      address={address}
                      setAddress={setAddress}
                      isEditingMarkerPosition={isEditingMarkerPosition}
                      showInputAutocomplete={true}
                      // colonySelected={colonySelected}
                      // setColonySelected={setColonySelected}
                    />
                  )}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default WaterStationsNew
